/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 0.0.1
 */

/**
 * Publication status of the report
 */
export type CreateReportDtoStatus =
  (typeof CreateReportDtoStatus)[keyof typeof CreateReportDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateReportDtoStatus = {
  publishedRRA: 'publishedRRA',
  pendingRRA: 'pendingRRA',
  draft: 'draft',
  published: 'published',
  incorrect: 'incorrect',
} as const;
